import api from '@/lib/axios'

export interface Document {
  id: string
  project_id: string
  org_id: string
  filename: string
  original_filename: string
  file_type: string
  page_count: number | null
  file_size_bytes: number | null
  status: string
  uploaded_by: string
  uploaded_at: string
  processed_at: string | null
  error_message: string | null
  last_extraction_status: string | null
  last_extraction_at: string | null
  avg_confidence: number | null
  annotation_count: number
  conversion_status: string | null  // 'converted' | 'failed' | 'not_required' | null
  conversion_error: string | null
}

export interface DocumentPage {
  id: string
  document_id: string
  page_number: number
  text_content: string | null
}

export const documentsApi = {
  list: (projectId: string) =>
    api.get<Document[]>('/documents', { params: { project_id: projectId } }).then((r) => r.data),

  upload: (projectId: string, file: File) => {
    const formData = new FormData()
    formData.append('project_id', projectId)
    formData.append('file', file)
    return api
      .post<Document>('/documents', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data)
  },

  get: (id: string) => api.get<Document>(`/documents/${id}`).then((r) => r.data),

  getDownloadUrl: (id: string) =>
    api.get<{ url: string }>(`/documents/${id}/download-url`).then((r) => r.data),

  getPages: (id: string) =>
    api.get<DocumentPage[]>(`/documents/${id}/pages`).then((r) => r.data),

  delete: (id: string) => api.delete(`/documents/${id}`).then((r) => r.data),

  retryParse: (id: string) =>
    api.post<{ id: string; status: string; queued: boolean }>(`/documents/${id}/retry-parse`).then((r) => r.data),

  retryStuck: (projectId: string) =>
    api.post<{ requeued: number }>('/documents/retry-stuck', null, { params: { project_id: projectId } }).then((r) => r.data),
}
